export const Cap = [
  {
    store: '0105',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0106',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0110',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0111',
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: '0114',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 192,
    February: 192
  },
  {
    store: '0115',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0116',
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 384,
    February: 384
  },
  {
    store: '0117',
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: '0118',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0119',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288
  },
  {
    store: '0121',
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: '0122',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0123',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0126',
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: '0127',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0128',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0129',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 250
  },
  {
    store: '0130',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0131',
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: '0132',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0133',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0134',
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 404,
    September: 404,
    October: 404,
    November: 480,
    'Black Friday': 480,
    December: 480,
    January: 480,
    February: 480
  },
  {
    store: '0136',
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: '0137',
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307
  },
  {
    store: '0138',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0139',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0140',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0141',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0143',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0144',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 288
  },
  {
    store: '0145',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0146',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 422,
    February: 422
  },
  {
    store: '0147',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 403,
    February: 403
  },
  {
    store: '0148',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0149',
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: '0151',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0152',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0153',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 288,
    February: 365
  },
  {
    store: '0154',
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: '0155',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0156',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0157',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0159',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0160',
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: '0161',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 250
  },
  {
    store: '0163',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0164',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250,
    February: 250
  },
  {
    store: '0165',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0170',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0172',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0174',
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: '0175',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0178',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0179',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0201',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 230,
    February: 230
  },
  {
    store: '0202',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0203',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0204',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0205',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0206',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0207',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0208',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0209',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0210',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0213',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0218',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0220',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0221',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0222',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0224',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: '0226',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0232',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0233',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0234',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0238',
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: '0243',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0244',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0245',
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 307
  },
  {
    store: '0247',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0248',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0249',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0251',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: '0253',
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: '0254',
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: '0255',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 307
  },
  {
    store: '0256',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0257',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0258',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0260',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250,
    February: 326
  },
  {
    store: '0261',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0262',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0263',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0264',
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: '0265',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0266',
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: '0268',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0270',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0272',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 288,
    February: 365
  },
  {
    store: '0273',
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: '0274',
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: '0275',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0276',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0277',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0278',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 192,
    February: 192
  },
  {
    store: '0279',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0280',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: '0281',
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: '0283',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0284',
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: '0285',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0287',
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 307,
    February: 307
  },
  {
    store: '0288',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0289',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0347',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0349',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0352',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0356',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0357',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0358',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0359',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0360',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0362',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0363',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0364',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0365',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0366',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0367',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0368',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0370',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0371',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0373',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0374',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0375',
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 422,
    February: 422
  },
  {
    store: '0376',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0378',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0380',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0381',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0383',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0385',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0386',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0389',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0401',
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: '0402',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0403',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 230,
    February: 230
  },
  {
    store: '0404',
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: '0405',
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 499,
    February: 499
  },
  {
    store: '0406',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 288,
    February: 288
  },
  {
    store: '0408',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0410',
    March: 519,
    April: 519,
    May: 519,
    June: 519,
    July: 519,
    August: 519,
    September: 519,
    October: 519,
    November: 519,
    'Black Friday': 519,
    December: 519,
    January: 518,
    February: 518
  },
  {
    store: '0411',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0413',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 422
  },
  {
    store: '0414',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0415',
    March: 384,
    April: 384,
    May: 384,
    June: 384,
    July: 384,
    August: 384,
    September: 384,
    October: 384,
    November: 500,
    'Black Friday': 500,
    December: 500,
    January: 576,
    February: 576
  },
  {
    store: '0416',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0417',
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: '0419',
    March: 384,
    April: 384,
    May: 384,
    June: 384,
    July: 384,
    August: 384,
    September: 384,
    October: 384,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384,
    February: 384
  },
  {
    store: '0420',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0421',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0422',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0423',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0424',
    March: 346,
    April: 346,
    May: 480,
    June: 480,
    July: 480,
    August: 480,
    September: 480,
    October: 480,
    November: 480,
    'Black Friday': 480,
    December: 480,
    January: 480,
    February: 480
  },
  {
    store: '0428',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0429',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250,
    February: 250
  },
  {
    store: '0430',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0431',
    March: 0,
    April: 135,
    May: 173,
    June: 173,
    July: 173,
    August: 308,
    September: 308,
    October: 308,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 614,
    February: 614
  },
  {
    store: '0432',
    March: 404,
    April: 404,
    May: 404,
    June: 404,
    July: 404,
    August: 404,
    September: 404,
    October: 404,
    November: 404,
    'Black Friday': 404,
    December: 404,
    January: 403,
    February: 403
  },
  {
    store: '0441',
    March: 634,
    April: 634,
    May: 634,
    June: 634,
    July: 634,
    August: 634,
    September: 634,
    October: 634,
    November: 711,
    'Black Friday': 711,
    December: 711,
    January: 710,
    February: 806
  },
  {
    store: '0442',
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: '0443',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0445',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0446',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0447',
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 500,
    'Black Friday': 500,
    December: 500,
    January: 557,
    February: 557
  },
  {
    store: '0452',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0453',
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: '0455',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0456',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: '0457',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0458',
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: '0459',
    March: 173,
    April: 173,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: '0464',
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: '0467',
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 307,
    February: 307
  },
  {
    store: '0468',
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 404,
    September: 404,
    October: 404,
    November: 404,
    'Black Friday': 404,
    December: 404,
    January: 403,
    February: 403
  },
  {
    store: '0469',
    March: 404,
    April: 404,
    May: 442,
    June: 442,
    July: 442,
    August: 442,
    September: 442,
    October: 442,
    November: 442,
    'Black Friday': 442,
    December: 442,
    January: 480,
    February: 480
  },
  {
    store: '0470',
    March: 308,
    April: 308,
    May: 308,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 365
  },
  {
    store: '0471',
    March: 288,
    April: 288,
    May: 288,
    June: 288,
    July: 288,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: '0472',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0473',
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: '0474',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 365,
    February: 365
  },
  {
    store: '0475',
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: '0476',
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: '0477',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288
  },
  {
    store: '0478',
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: '0480',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0481',
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 307,
    February: 307
  },
  {
    store: '0482',
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: '0483',
    March: 384,
    April: 384,
    May: 384,
    June: 384,
    July: 384,
    August: 384,
    September: 384,
    October: 384,
    November: 461,
    'Black Friday': 461,
    December: 461,
    January: 499,
    February: 499
  },
  {
    store: '0485',
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: '0486',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0488',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0489',
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: '0501',
    March: 135,
    April: 135,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0503',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0504',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0505',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0506',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0507',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0508',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0509',
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: '0513',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0514',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0516',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 250
  },
  {
    store: '0518',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0519',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0522',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0523',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0524',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0526',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0527',
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: '0528',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0529',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0530',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: '0531',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0534',
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 307,
    February: 307
  },
  {
    store: '0537',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0539',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0540',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0541',
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: '0542',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0550',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0551',
    March: 288,
    April: 288,
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288
  },
  {
    store: '0552',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0553',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0554',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0555',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0556',
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: '0561',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0562',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0563',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0564',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0565',
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: '0566',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: '0568',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: '0569',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 250
  },
  {
    store: '0571',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 192,
    February: 192
  },
  {
    store: '0574',
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: '0576',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0577',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0578',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0580',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0581',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0582',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0583',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0584',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0585',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 192,
    February: 192
  },
  {
    store: '0586',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0587',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0588',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0589',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0597',
    March: 0,
    April: 0,
    May: 173,
    June: 173,
    July: 173,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: '0598',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0601',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0603',
    March: 384,
    April: 384,
    May: 384,
    June: 384,
    July: 384,
    August: 384,
    September: 384,
    October: 384,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384,
    February: 384
  },
  {
    store: '0606',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0607',
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: '0608',
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: '0609',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0610',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0611',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0612',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 269,
    February: 269
  },
  {
    store: '0614',
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: '0615',
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: '0616',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0618',
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 423,
    'Black Friday': 423,
    December: 423,
    January: 422,
    February: 422
  },
  {
    store: '0620',
    March: 442,
    April: 442,
    May: 442,
    June: 442,
    July: 442,
    August: 442,
    September: 442,
    October: 442,
    November: 442,
    'Black Friday': 442,
    December: 442,
    January: 442,
    February: 442
  },
  {
    store: '0625',
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: '0627',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: '0628',
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: '0629',
    March: 596,
    April: 596,
    May: 596,
    June: 596,
    July: 596,
    August: 596,
    September: 596,
    October: 596,
    November: 596,
    'Black Friday': 596,
    December: 596,
    January: 595,
    February: 595
  },
  {
    store: '0630',
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: '0632',
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: '0633',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0634',
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: '0635',
    March: 288,
    April: 288,
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288
  },
  {
    store: '0636',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 288,
    February: 288
  },
  {
    store: '0637',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0638',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0639',
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: '0640',
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: '0641',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0642',
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: '0643',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 250,
    February: 346
  },
  {
    store: '0644',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0645',
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: '0647',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0648',
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: '0649',
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: '0650',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0651',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0652',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 307,
    February: 307
  },
  {
    store: '0653',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0654',
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: '0657',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0658',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0659',
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 326,
    February: 326
  },
  {
    store: '0660',
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: '0662',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0663',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 288,
    February: 288
  },
  {
    store: '0664',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0665',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0667',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0668',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0669',
    March: 423,
    April: 423,
    May: 423,
    June: 423,
    July: 423,
    August: 423,
    September: 423,
    October: 423,
    November: 423,
    'Black Friday': 423,
    December: 423,
    January: 422,
    February: 422
  },
  {
    store: '0671',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0673',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0674',
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365,
    February: 365
  },
  {
    store: '0679',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0680',
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: '0683',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0684',
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: '0687',
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: '0701',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0702',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 211,
    February: 288
  },
  {
    store: '0703',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0704',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0707',
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: '0711',
    March: 0,
    April: 0,
    May: 0,
    June: 0,
    July: 0,
    August: 0,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0720',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0721',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0722',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 211,
    February: 288
  },
  {
    store: '0723',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: '0724',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0725',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0726',
    March: 480,
    April: 480,
    May: 480,
    June: 480,
    July: 480,
    August: 480,
    September: 480,
    October: 480,
    November: 480,
    'Black Friday': 480,
    December: 480,
    January: 480,
    February: 480
  },
  {
    store: '0727',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 230
  },
  {
    store: '0728',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: '0729',
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: '0730',
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: '0731',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0732',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0733',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 403,
    February: 403
  },
  {
    store: '0734',
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 307,
    February: 307
  },
  {
    store: '0735',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0736',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0737',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0739',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0740',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0742',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: '0743',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 173,
    February: 173
  },
  {
    store: '0744',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0745',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0747',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0748',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0770',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0772',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0773',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0775',
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: '0776',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 269
  },
  {
    store: '0778',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 269,
    February: 269
  },
  {
    store: '0779',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0801',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 288,
    February: 326
  },
  {
    store: '0802',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0803',
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: '0804',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0805',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0806',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0808',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0809',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0810',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0812',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0813',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0816',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0817',
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: '0818',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0863',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0865',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0866',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0875',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0877',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0880',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0881',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0882',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0883',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0884',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 211,
    February: 250
  },
  {
    store: '0887',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: '0888',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0901',
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: '0902',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0903',
    March: 404,
    April: 404,
    May: 404,
    June: 404,
    July: 404,
    August: 404,
    September: 404,
    October: 404,
    November: 404,
    'Black Friday': 404,
    December: 404,
    January: 403,
    February: 403
  },
  {
    store: '0904',
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: '0906',
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 346,
    February: 346
  },
  {
    store: '0907',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0908',
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: '0909',
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: '0910',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0912',
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: '0914',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0915',
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: '0916',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0917',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: '0918',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0919',
    March: 308,
    April: 308,
    May: 308,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307
  },
  {
    store: '0920',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0921',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 326
  },
  {
    store: '0922',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0925',
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: '0926',
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 288,
    February: 288
  },
  {
    store: '0927',
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307
  },
  {
    store: '0928',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0929',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0930',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0931',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0932',
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: '0933',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0934',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0935',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0939',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 423,
    September: 423,
    October: 423,
    November: 538,
    'Black Friday': 538,
    December: 538,
    January: 538,
    February: 538
  },
  {
    store: '0940',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0941',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0942',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0943',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0944',
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: '0946',
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: '0947',
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 250,
    February: 250
  },
  {
    store: '0949',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0950',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0951',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0953',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0954',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0957',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0959',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0961',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0962',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 211,
    February: 211
  },
  {
    store: '0963',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0965',
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: '0969',
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: '0970',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0974',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: '0975',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0976',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0977',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 384,
    February: 480
  },
  {
    store: '0980',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: '0981',
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: '0982',
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: '0983',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 250
  },
  {
    store: '0984',
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288
  },
  {
    store: '0989',
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1001,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1002,
    March: 576,
    April: 576,
    May: 576,
    June: 576,
    July: 576,
    August: 576,
    September: 576,
    October: 576,
    November: 576,
    'Black Friday': 576,
    December: 576,
    January: 576,
    February: 576
  },
  {
    store: 1003,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1005,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 307
  },
  {
    store: 1006,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 595,
    February: 595
  },
  {
    store: 1007,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1009,
    March: 365,
    April: 365,
    May: 365,
    June: 365,
    July: 365,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365,
    February: 365
  },
  {
    store: 1010,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1012,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1013,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1014,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1017,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 1018,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1019,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 250,
    February: 250
  },
  {
    store: 1020,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1022,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1028,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 422,
    February: 422
  },
  {
    store: 1030,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1031,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 250,
    February: 250
  },
  {
    store: 1032,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 1034,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1037,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1039,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1040,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 1041,
    March: 384,
    April: 384,
    May: 384,
    June: 384,
    July: 384,
    August: 384,
    September: 384,
    October: 384,
    November: 423,
    'Black Friday': 423,
    December: 423,
    January: 384,
    February: 384
  },
  {
    store: 1043,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1044,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1048,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 557,
    February: 557
  },
  {
    store: 1050,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1052,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1053,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 1055,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1059,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1060,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1061,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 192,
    February: 192
  },
  {
    store: 1062,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1064,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 1068,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1069,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1070,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1072,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 1073,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250,
    February: 326
  },
  {
    store: 1074,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1076,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1077,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 403,
    February: 403
  },
  {
    store: 1080,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 326,
    February: 326
  },
  {
    store: 1083,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: 1084,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 384
  },
  {
    store: 1085,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1086,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1087,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1088,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1089,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1092,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 1103,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 211
  },
  {
    store: 1104,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1105,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1106,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1108,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1109,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250,
    February: 326
  },
  {
    store: 1110,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1112,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1114,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 1115,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1116,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1117,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1118,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1119,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1120,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 288,
    February: 346
  },
  {
    store: 1121,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1122,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1124,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1126,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1127,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 230
  },
  {
    store: 1129,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1130,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1171,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 269,
    February: 326
  },
  {
    store: 1202,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1206,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1207,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1208,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1209,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1211,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1212,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 1213,
    March: 288,
    April: 288,
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288
  },
  {
    store: 1214,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 1215,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1216,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1217,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1218,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1220,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365,
    February: 365
  },
  {
    store: 1221,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1222,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1223,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1225,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 1227,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1228,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1229,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1230,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1231,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1233,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1234,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1235,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1236,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1238,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1239,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1241,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1242,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 1244,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1245,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1246,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1247,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1248,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1249,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1250,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1251,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 288
  },
  {
    store: 1252,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 1254,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1255,
    March: 192,
    April: 192,
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288
  },
  {
    store: 1256,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 1257,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1258,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1259,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1261,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1262,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1263,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 1264,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1265,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1266,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1267,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1268,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 307,
    February: 365
  },
  {
    store: 1271,
    March: 212,
    April: 212,
    May: 308,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307
  },
  {
    store: 1272,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1273,
    March: 212,
    April: 212,
    May: 308,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307
  },
  {
    store: 1274,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1277,
    March: 500,
    April: 500,
    May: 500,
    June: 500,
    July: 500,
    August: 500,
    September: 500,
    October: 500,
    November: 500,
    'Black Friday': 500,
    December: 500,
    January: 499,
    February: 499
  },
  {
    store: 1278,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250,
    February: 250
  },
  {
    store: 1281,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250,
    February: 250
  },
  {
    store: 1282,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1284,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1285,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 1286,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1287,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 307
  },
  {
    store: 1289,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1301,
    March: 173,
    April: 173,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 211
  },
  {
    store: 1302,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1303,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1304,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 269,
    February: 346
  },
  {
    store: 1324,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 404,
    'Black Friday': 404,
    December: 404,
    January: 403,
    February: 403
  },
  {
    store: 1326,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1349,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 403
  },
  {
    store: 1379,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1380,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1401,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 230,
    February: 230
  },
  {
    store: 1402,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 211,
    February: 288
  },
  {
    store: 1403,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1404,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 1405,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1406,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 250,
    February: 326
  },
  {
    store: 1407,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1409,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1410,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1411,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1412,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1501,
    March: 404,
    April: 404,
    May: 404,
    June: 404,
    July: 404,
    August: 404,
    September: 404,
    October: 404,
    November: 404,
    'Black Friday': 404,
    December: 404,
    January: 403,
    February: 403
  },
  {
    store: 1502,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 1503,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1504,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 1505,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1506,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1507,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 1508,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 1509,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1510,
    March: 596,
    April: 596,
    May: 596,
    June: 596,
    July: 596,
    August: 596,
    September: 596,
    October: 596,
    November: 596,
    'Black Friday': 596,
    December: 596,
    January: 595,
    February: 595
  },
  {
    store: 1511,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1512,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 1513,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1514,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1515,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 307
  },
  {
    store: 1516,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 1517,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: 1518,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1519,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1520,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1521,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1522,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1523,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 1524,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288
  },
  {
    store: 1525,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1526,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 1528,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 307
  },
  {
    store: 1529,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250,
    February: 250
  },
  {
    store: 1531,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 1532,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1534,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1535,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1537,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1538,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1540,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365,
    February: 365
  },
  {
    store: 1541,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1542,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1544,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1545,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1546,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1547,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 250,
    September: 250,
    October: 250,
    November: 461,
    'Black Friday': 461,
    December: 461,
    January: 499,
    February: 499
  },
  {
    store: 1548,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288
  },
  {
    store: 1549,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1550,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1551,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1552,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1601,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 269
  },
  {
    store: 1602,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 192,
    February: 192
  },
  {
    store: 1603,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 192,
    February: 192
  },
  {
    store: 1604,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1605,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1608,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1610,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1701,
    March: 557,
    April: 557,
    May: 557,
    June: 557,
    July: 557,
    August: 557,
    September: 557,
    October: 557,
    November: 557,
    'Black Friday': 557,
    December: 557,
    January: 557,
    February: 614
  },
  {
    store: 1702,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: 1703,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 1704,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1705,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1706,
    March: 519,
    April: 519,
    May: 519,
    June: 519,
    July: 519,
    August: 519,
    September: 519,
    October: 519,
    November: 519,
    'Black Friday': 519,
    December: 519,
    January: 518,
    February: 518
  },
  {
    store: 1707,
    March: 173,
    April: 173,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 1710,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 1747,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1748,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1749,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1750,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1754,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1755,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 1763,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 1764,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1769,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1770,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1771,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 250,
    February: 250
  },
  {
    store: 1772,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1773,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1774,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1775,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1777,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1801,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 288,
    February: 288
  },
  {
    store: 1802,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 1803,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1804,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250,
    February: 250
  },
  {
    store: 1805,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 288,
    February: 384
  },
  {
    store: 1806,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 1807,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 1808,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1809,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1810,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1811,
    March: 0,
    April: 0,
    May: 0,
    June: 0,
    July: 0,
    August: 0,
    September: 0,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1832,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 1840,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1842,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1843,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1844,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 1845,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 326,
    February: 326
  },
  {
    store: 1846,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 1848,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1851,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1853,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1854,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1855,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1856,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1857,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 374
  },
  {
    store: 1858,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 269
  },
  {
    store: 1859,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1861,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1863,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 269,
    February: 269
  },
  {
    store: 1866,
    March: 0,
    April: 0,
    May: 0,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1901,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1902,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 1903,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1904,
    March: 346,
    April: 346,
    May: 384,
    June: 384,
    July: 384,
    August: 384,
    September: 384,
    October: 384,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384,
    February: 384
  },
  {
    store: 1905,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 211,
    February: 211
  },
  {
    store: 1906,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 1907,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307
  },
  {
    store: 1908,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1909,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1911,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1912,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1913,
    March: 500,
    April: 500,
    May: 500,
    June: 500,
    July: 500,
    August: 500,
    September: 500,
    October: 500,
    November: 500,
    'Black Friday': 500,
    December: 500,
    January: 499,
    February: 499
  },
  {
    store: 1914,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1915,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 250,
    February: 250
  },
  {
    store: 1916,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 422,
    February: 422
  },
  {
    store: 1917,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1918,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: 1919,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1920,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 1921,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1922,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1924,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1926,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 1927,
    March: 404,
    April: 404,
    May: 404,
    June: 404,
    July: 404,
    August: 404,
    September: 404,
    October: 404,
    November: 404,
    'Black Friday': 404,
    December: 404,
    January: 403,
    February: 403
  },
  {
    store: 1928,
    March: 423,
    April: 423,
    May: 423,
    June: 423,
    July: 423,
    August: 423,
    September: 423,
    October: 423,
    November: 423,
    'Black Friday': 423,
    December: 423,
    January: 422,
    February: 422
  },
  {
    store: 1932,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1934,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 1935,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1936,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1937,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 384,
    February: 384
  },
  {
    store: 1938,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1939,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 288,
    February: 288
  },
  {
    store: 1940,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 1941,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1942,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 288,
    February: 288
  },
  {
    store: 1943,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1944,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1948,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1950,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 1952,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 1955,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1956,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1957,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 230
  },
  {
    store: 1961,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1962,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 1964,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1967,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1969,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 1973,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1974,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1975,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 1976,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1977,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1978,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1979,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1980,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 1981,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 1982,
    March: 308,
    April: 308,
    May: 308,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307
  },
  {
    store: 1983,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 1984,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1986,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 1987,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 1989,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2001,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 230,
    February: 230
  },
  {
    store: 2002,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2003,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 2009,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: 2010,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2011,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2012,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 2014,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2016,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 2017,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 2018,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 326,
    February: 326
  },
  {
    store: 2019,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 307,
    February: 307
  },
  {
    store: 2021,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2023,
    March: 154,
    April: 154,
    May: 173,
    June: 173,
    July: 173,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2024,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2025,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2026,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2030,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 2033,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2034,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 2036,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2037,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 2101,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2103,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 2104,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 2107,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288
  },
  {
    store: 2108,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365,
    February: 365
  },
  {
    store: 2109,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2111,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 2113,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 230,
    February: 230
  },
  {
    store: 2114,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307
  },
  {
    store: 2115,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 2201,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 2202,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 269,
    February: 269
  },
  {
    store: 2203,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 2204,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: 2205,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 2207,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288
  },
  {
    store: 2209,
    March: 404,
    April: 404,
    May: 404,
    June: 404,
    July: 404,
    August: 461,
    September: 461,
    October: 461,
    November: 461,
    'Black Friday': 461,
    December: 461,
    January: 499,
    February: 499
  },
  {
    store: 2211,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2213,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 2214,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2216,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 2217,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 2218,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 2219,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2220,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2221,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 2301,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 2302,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2303,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 2304,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384,
    February: 384
  },
  {
    store: 2305,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 269,
    February: 307
  },
  {
    store: 2306,
    March: 384,
    April: 384,
    May: 384,
    June: 384,
    July: 384,
    August: 384,
    September: 384,
    October: 384,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384,
    February: 384
  },
  {
    store: 2307,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2313,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 326
  },
  {
    store: 2314,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2315,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 461,
    February: 595
  },
  {
    store: 2316,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 2317,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2318,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2323,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 2324,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2389,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 326,
    February: 326
  },
  {
    store: 2401,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2403,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2404,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2405,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2406,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 2407,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 269
  },
  {
    store: 2408,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2409,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2410,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2412,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2414,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2501,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2502,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2503,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2504,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2505,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 2506,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 2507,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2509,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 269
  },
  {
    store: 2510,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2511,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 211,
    February: 288
  },
  {
    store: 2550,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 2551,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 2552,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2554,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2555,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2557,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2558,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 461,
    February: 461
  },
  {
    store: 2559,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 269,
    February: 384
  },
  {
    store: 2560,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 288,
    February: 365
  },
  {
    store: 2561,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2562,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2563,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 2564,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2565,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 2566,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365,
    February: 365
  },
  {
    store: 2567,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2571,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 230
  },
  {
    store: 2575,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 2576,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2577,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2578,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2579,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2580,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2581,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2582,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 250
  },
  {
    store: 2583,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2584,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2587,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2589,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2602,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 2603,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2605,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 614,
    February: 614
  },
  {
    store: 2607,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2608,
    March: 212,
    April: 212,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 269,
    February: 269
  },
  {
    store: 2609,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 2610,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2611,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2612,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2613,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2614,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 2615,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 2619,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2623,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2624,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 2650,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 230
  },
  {
    store: 2651,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 2653,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 230,
    February: 230
  },
  {
    store: 2659,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2662,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 2663,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 2665,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2667,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2668,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: 2669,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 307,
    February: 307
  },
  {
    store: 2670,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2671,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 2672,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365,
    February: 365
  },
  {
    store: 2673,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2674,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: 2676,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 2677,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2678,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2679,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 250,
    February: 326
  },
  {
    store: 2680,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 173,
    February: 173
  },
  {
    store: 2681,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 346
  },
  {
    store: 2682,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 2683,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2684,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: 2685,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2686,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 230
  },
  {
    store: 2688,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 2701,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2702,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 250
  },
  {
    store: 2703,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 288,
    February: 288
  },
  {
    store: 2704,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 2706,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 2707,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2708,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 2709,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2710,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 2711,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2714,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2715,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 2716,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2717,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2718,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2720,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 2721,
    March: 269,
    April: 269,
    May: 384,
    June: 384,
    July: 384,
    August: 384,
    September: 384,
    October: 384,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384,
    February: 422
  },
  {
    store: 2722,
    March: 192,
    April: 192,
    May: 231,
    June: 231,
    July: 231,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307
  },
  {
    store: 2723,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 2724,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 2725,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2726,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2727,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 2728,
    March: 288,
    April: 288,
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288
  },
  {
    store: 2729,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2731,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2732,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2733,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2734,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2736,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2737,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2738,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2739,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2740,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 2741,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2742,
    March: 212,
    April: 212,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 2743,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 2744,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2747,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2748,
    March: 288,
    April: 288,
    May: 288,
    June: 288,
    July: 288,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 403,
    February: 403
  },
  {
    store: 2751,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 2752,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2754,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2755,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2757,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2758,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 2759,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2760,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2761,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 2762,
    March: 192,
    April: 192,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 288,
    February: 288
  },
  {
    store: 2763,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 2764,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 211
  },
  {
    store: 2765,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2766,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2767,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2768,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2769,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2770,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2771,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2772,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2773,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2775,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2776,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 2779,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2780,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2781,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2782,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2785,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2789,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 2801,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 211,
    February: 211
  },
  {
    store: 2802,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 2803,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 346,
    September: 346,
    October: 346,
    November: 423,
    'Black Friday': 423,
    December: 423,
    January: 422,
    February: 422
  },
  {
    store: 2804,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 307
  },
  {
    store: 2805,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 230
  },
  {
    store: 2806,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365,
    February: 365
  },
  {
    store: 2807,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 2808,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 423,
    September: 423,
    October: 423,
    November: 423,
    'Black Friday': 423,
    December: 423,
    January: 422,
    February: 422
  },
  {
    store: 2809,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 2810,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 384,
    September: 384,
    October: 384,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384,
    February: 384
  },
  {
    store: 2811,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365,
    February: 365
  },
  {
    store: 2812,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: 2813,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 2817,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288
  },
  {
    store: 2818,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2820,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 2821,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 2825,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 2826,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 442,
    February: 461
  },
  {
    store: 2828,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2829,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307
  },
  {
    store: 2830,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2831,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2832,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2833,
    March: 557,
    April: 557,
    May: 557,
    June: 557,
    July: 557,
    August: 634,
    September: 634,
    October: 634,
    November: 634,
    'Black Friday': 634,
    December: 634,
    January: 691,
    February: 691
  },
  {
    store: 2834,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2840,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 269
  },
  {
    store: 2841,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307
  },
  {
    store: 2842,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 2843,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 2844,
    March: 346,
    April: 346,
    May: 423,
    June: 423,
    July: 423,
    August: 442,
    September: 442,
    October: 442,
    November: 442,
    'Black Friday': 442,
    December: 442,
    January: 442,
    February: 442
  },
  {
    store: 2845,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288
  },
  {
    store: 2847,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 2901,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 2902,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2903,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2905,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2906,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2907,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2909,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2910,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2912,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2913,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2914,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2915,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 2917,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3001,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 3002,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3003,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3004,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3006,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3007,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3008,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3009,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3010,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3011,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3012,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3013,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3014,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3015,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 3016,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3018,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3019,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 288
  },
  {
    store: 3021,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3022,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 307,
    February: 307
  },
  {
    store: 3024,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 3025,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 3026,
    March: 231,
    April: 231,
    May: 308,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 384,
    February: 384
  },
  {
    store: 3027,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3029,
    March: 173,
    April: 173,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 3032,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3033,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3034,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3036,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3037,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3038,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3042,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3101,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 212,
    September: 212,
    October: 212,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 3102,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3103,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 230,
    February: 230
  },
  {
    store: 3104,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3105,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3106,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3117,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250,
    February: 250
  },
  {
    store: 3118,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 250,
    February: 250
  },
  {
    store: 3119,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 230
  },
  {
    store: 3201,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288
  },
  {
    store: 3202,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 3203,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 3204,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 500,
    September: 500,
    October: 500,
    November: 576,
    'Black Friday': 576,
    December: 576,
    January: 576,
    February: 576
  },
  {
    store: 3206,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 3208,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 3209,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 3210,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 3301,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3302,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 346,
    February: 422
  },
  {
    store: 3303,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3304,
    March: 173,
    April: 173,
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288
  },
  {
    store: 3305,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307
  },
  {
    store: 3306,
    March: 288,
    April: 288,
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288
  },
  {
    store: 3307,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 250
  },
  {
    store: 3308,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3309,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: 3310,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3311,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 250
  },
  {
    store: 3312,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3313,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 3314,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3315,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3316,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 250
  },
  {
    store: 3318,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3320,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3322,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3324,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3331,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 3401,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 403
  },
  {
    store: 3402,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3403,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3404,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3405,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3406,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3407,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3408,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3409,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3480,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3481,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 3482,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3484,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 3485,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3486,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3487,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3488,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3489,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3501,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 3502,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3503,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3504,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 3505,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3507,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288
  },
  {
    store: 3508,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 250,
    February: 250
  },
  {
    store: 3510,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3511,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3514,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3515,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3516,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3517,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3601,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3602,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 230
  },
  {
    store: 3603,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 3604,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3605,
    March: 308,
    April: 308,
    May: 308,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307
  },
  {
    store: 3606,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3607,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307
  },
  {
    store: 3608,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 3609,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3610,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 365,
    February: 365
  },
  {
    store: 3615,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 3616,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3620,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 3625,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3626,
    March: 442,
    April: 442,
    May: 442,
    June: 442,
    July: 442,
    August: 442,
    September: 442,
    October: 442,
    November: 442,
    'Black Friday': 442,
    December: 442,
    January: 442,
    February: 442
  },
  {
    store: 3627,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 230
  },
  {
    store: 3628,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 211,
    February: 211
  },
  {
    store: 3629,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3631,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 3632,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3633,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3634,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 288,
    February: 288
  },
  {
    store: 3637,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3638,
    March: 384,
    April: 384,
    May: 384,
    June: 384,
    July: 384,
    August: 384,
    September: 384,
    October: 384,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384,
    February: 384
  },
  {
    store: 3639,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3640,
    March: 308,
    April: 308,
    May: 308,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307
  },
  {
    store: 3641,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3642,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3644,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 423,
    'Black Friday': 423,
    December: 423,
    January: 538,
    February: 538
  },
  {
    store: 3645,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3646,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3647,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 3648,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3650,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3651,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3652,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 596,
    September: 596,
    October: 596,
    November: 711,
    'Black Friday': 711,
    December: 711,
    January: 710,
    February: 710
  },
  {
    store: 3655,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 3661,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3662,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 3663,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 3701,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: 3703,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 3801,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3803,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 3804,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3805,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3806,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 3807,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 269,
    February: 346
  },
  {
    store: 3808,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3809,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3810,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3811,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3812,
    March: 365,
    April: 365,
    May: 365,
    June: 365,
    July: 365,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365,
    February: 365
  },
  {
    store: 3813,
    March: 384,
    April: 384,
    May: 384,
    June: 384,
    July: 384,
    August: 461,
    September: 461,
    October: 461,
    November: 461,
    'Black Friday': 461,
    December: 461,
    January: 461,
    February: 461
  },
  {
    store: 3814,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3815,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3816,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3817,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3818,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3819,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3820,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3821,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3822,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 3823,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3824,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3825,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 269,
    February: 269
  },
  {
    store: 3827,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3828,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 3830,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3831,
    March: 500,
    April: 500,
    May: 500,
    June: 500,
    July: 500,
    August: 500,
    September: 500,
    October: 500,
    November: 500,
    'Black Friday': 500,
    December: 500,
    January: 499,
    February: 499
  },
  {
    store: 3832,
    March: 288,
    April: 288,
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288
  },
  {
    store: 3833,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3835,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 3836,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 365,
    February: 365
  },
  {
    store: 3838,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3841,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3842,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 307,
    February: 307
  },
  {
    store: 3843,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3844,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3846,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3847,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3848,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 3852,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3854,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 3855,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3856,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3857,
    March: 192,
    April: 192,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 3858,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3859,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 3860,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3861,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 326,
    February: 326
  },
  {
    store: 3862,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3863,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3864,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 173,
    February: 192
  },
  {
    store: 3866,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3867,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3868,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 3872,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 3875,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 3877,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3882,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 3883,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3885,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3886,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3887,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3888,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3889,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 3901,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3902,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3903,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 3904,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 3906,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3907,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 3908,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3909,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3911,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3913,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 3914,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 3915,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 3917,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 3918,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 3919,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4001,
    March: 1191,
    April: 1191,
    May: 1191,
    June: 1191,
    July: 1191,
    August: 1191,
    September: 1191,
    October: 1191,
    November: 1191,
    'Black Friday': 1191,
    December: 1191,
    January: 1382,
    February: 1382
  },
  {
    store: 4002,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 4003,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 4004,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4006,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 4007,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 4008,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4009,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307
  },
  {
    store: 4010,
    March: 519,
    April: 519,
    May: 519,
    June: 519,
    July: 519,
    August: 519,
    September: 519,
    October: 519,
    November: 519,
    'Black Friday': 519,
    December: 519,
    January: 518,
    February: 518
  },
  {
    store: 4013,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 250,
    February: 250
  },
  {
    store: 4014,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307
  },
  {
    store: 4015,
    March: 308,
    April: 308,
    May: 308,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307
  },
  {
    store: 4017,
    March: 538,
    April: 538,
    May: 538,
    June: 538,
    July: 538,
    August: 538,
    September: 538,
    October: 538,
    November: 538,
    'Black Friday': 538,
    December: 538,
    January: 538,
    February: 538
  },
  {
    store: 4018,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 4019,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4020,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4023,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4025,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4026,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4028,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4029,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4030,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 4031,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4032,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4034,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4040,
    March: 308,
    April: 308,
    May: 308,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384,
    February: 384
  },
  {
    store: 4054,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 4101,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 4102,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 4103,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4104,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288
  },
  {
    store: 4105,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 4106,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4108,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 4109,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4110,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 4112,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4113,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4114,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4115,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 288,
    February: 288
  },
  {
    store: 4116,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4117,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 4118,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4119,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 4120,
    March: 250,
    April: 250,
    May: 308,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 346,
    February: 346
  },
  {
    store: 4121,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 4122,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4123,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4124,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 4125,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 4126,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 4127,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 4128,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 288
  },
  {
    store: 4129,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 4130,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4131,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 346,
    February: 346
  },
  {
    store: 4132,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4134,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 4135,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 4136,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4137,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4138,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 461
  },
  {
    store: 4139,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4140,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 4141,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4142,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4143,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 4145,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 4148,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 230,
    February: 230
  },
  {
    store: 4149,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4150,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4152,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4156,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 4158,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250,
    February: 250
  },
  {
    store: 4159,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4160,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4162,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4163,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 4164,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4166,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4168,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4169,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4171,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 230,
    February: 230
  },
  {
    store: 4172,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4173,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4176,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4177,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4178,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4180,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 250
  },
  {
    store: 4181,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 4185,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4186,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 4187,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4188,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 269
  },
  {
    store: 4213,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4233,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 4279,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4280,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4282,
    March: 288,
    April: 288,
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288
  },
  {
    store: 4283,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 4284,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4285,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4286,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4287,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 4301,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 4401,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 384,
    February: 384
  },
  {
    store: 4402,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: 4403,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 4406,
    March: 500,
    April: 500,
    May: 500,
    June: 500,
    July: 500,
    August: 500,
    September: 500,
    October: 500,
    November: 538,
    'Black Friday': 538,
    December: 538,
    January: 653,
    February: 653
  },
  {
    store: 4407,
    March: 500,
    April: 500,
    May: 500,
    June: 500,
    July: 500,
    August: 500,
    September: 500,
    October: 500,
    November: 538,
    'Black Friday': 538,
    December: 538,
    January: 538,
    February: 538
  },
  {
    store: 4408,
    March: 557,
    April: 557,
    May: 557,
    June: 557,
    July: 557,
    August: 557,
    September: 557,
    October: 557,
    November: 557,
    'Black Friday': 557,
    December: 557,
    January: 557,
    February: 557
  },
  {
    store: 4409,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 4410,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 4411,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 4412,
    March: 557,
    April: 557,
    May: 557,
    June: 557,
    July: 557,
    August: 557,
    September: 557,
    October: 557,
    November: 672,
    'Black Friday': 672,
    December: 672,
    January: 710,
    February: 710
  },
  {
    store: 4413,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 4414,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 4415,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4416,
    March: 634,
    April: 634,
    May: 634,
    June: 634,
    July: 634,
    August: 634,
    September: 634,
    October: 634,
    November: 634,
    'Black Friday': 634,
    December: 634,
    January: 634,
    February: 634
  },
  {
    store: 4417,
    March: 672,
    April: 672,
    May: 672,
    June: 672,
    July: 672,
    August: 672,
    September: 672,
    October: 672,
    November: 672,
    'Black Friday': 672,
    December: 672,
    January: 672,
    February: 672
  },
  {
    store: 4418,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 250
  },
  {
    store: 4419,
    March: 308,
    April: 308,
    May: 308,
    June: 308,
    July: 308,
    August: 423,
    September: 423,
    October: 423,
    November: 423,
    'Black Friday': 423,
    December: 423,
    January: 422,
    February: 422
  },
  {
    store: 4420,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 480,
    September: 480,
    October: 480,
    November: 480,
    'Black Friday': 480,
    December: 480,
    January: 480,
    February: 480
  },
  {
    store: 4421,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 4422,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 4461,
    March: 730,
    April: 730,
    May: 730,
    June: 730,
    July: 730,
    August: 730,
    September: 730,
    October: 730,
    November: 768,
    'Black Friday': 768,
    December: 768,
    January: 730,
    February: 730
  },
  {
    store: 4462,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 4501,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 4502,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4551,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 230
  },
  {
    store: 4601,
    March: 423,
    April: 423,
    May: 423,
    June: 423,
    July: 423,
    August: 423,
    September: 423,
    October: 423,
    November: 423,
    'Black Friday': 423,
    December: 423,
    January: 422,
    February: 422
  },
  {
    store: 4602,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4603,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 4604,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 557,
    'Black Friday': 557,
    December: 557,
    January: 614,
    February: 768
  },
  {
    store: 4605,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4607,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4608,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 365
  },
  {
    store: 4609,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4611,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 4612,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4613,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4614,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 4615,
    March: 365,
    April: 365,
    May: 365,
    June: 365,
    July: 365,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365,
    February: 365
  },
  {
    store: 4616,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4617,
    March: 404,
    April: 404,
    May: 404,
    June: 404,
    July: 404,
    August: 404,
    September: 404,
    October: 404,
    November: 404,
    'Black Friday': 404,
    December: 404,
    January: 403,
    February: 403
  },
  {
    store: 4618,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4619,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 4620,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 4621,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 4622,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 4624,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 250,
    February: 250
  },
  {
    store: 4626,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 4627,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 4628,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4631,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4632,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4633,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4634,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 211,
    February: 211
  },
  {
    store: 4635,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4637,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4638,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 4639,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307
  },
  {
    store: 4640,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 4641,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 4643,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4645,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4647,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 4648,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4650,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4653,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4654,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4655,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4656,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4658,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4659,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4660,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4701,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 250,
    February: 250
  },
  {
    store: 4702,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4703,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 4704,
    March: 557,
    April: 557,
    May: 557,
    June: 557,
    July: 557,
    August: 557,
    September: 557,
    October: 557,
    November: 557,
    'Black Friday': 557,
    December: 557,
    January: 557,
    February: 557
  },
  {
    store: 4705,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 4706,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 4707,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 4708,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4709,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 4711,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 4712,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 403,
    February: 403
  },
  {
    store: 4713,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307
  },
  {
    store: 4714,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 4715,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4716,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 4718,
    March: 384,
    April: 384,
    May: 384,
    June: 384,
    July: 384,
    August: 480,
    September: 480,
    October: 480,
    November: 480,
    'Black Friday': 480,
    December: 480,
    January: 518,
    February: 538
  },
  {
    store: 4719,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 4720,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4722,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 4723,
    March: 730,
    April: 730,
    May: 730,
    June: 730,
    July: 730,
    August: 730,
    September: 730,
    October: 730,
    November: 730,
    'Black Friday': 730,
    December: 730,
    January: 730,
    February: 730
  },
  {
    store: 4724,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4725,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4726,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 4727,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 346,
    February: 346
  },
  {
    store: 4728,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 4732,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4734,
    March: 0,
    April: 0,
    May: 0,
    June: 0,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4735,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4737,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 4738,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 250
  },
  {
    store: 4739,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4740,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 4741,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 346,
    February: 346
  },
  {
    store: 4742,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4743,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4745,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4746,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 480,
    February: 480
  },
  {
    store: 4747,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 4748,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4801,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4802,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 4803,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4805,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 250
  },
  {
    store: 4878,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4902,
    March: 634,
    April: 634,
    May: 634,
    June: 634,
    July: 634,
    August: 634,
    September: 634,
    October: 634,
    November: 634,
    'Black Friday': 634,
    December: 634,
    January: 634,
    February: 634
  },
  {
    store: 4903,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 4905,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 4906,
    March: 404,
    April: 404,
    May: 404,
    June: 404,
    July: 404,
    August: 404,
    September: 404,
    October: 404,
    November: 404,
    'Black Friday': 404,
    December: 404,
    January: 403,
    February: 403
  },
  {
    store: 4907,
    March: 288,
    April: 288,
    May: 288,
    June: 288,
    July: 288,
    August: 384,
    September: 384,
    October: 384,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384,
    February: 384
  },
  {
    store: 4909,
    March: 519,
    April: 519,
    May: 576,
    June: 576,
    July: 576,
    August: 653,
    September: 653,
    October: 653,
    November: 653,
    'Black Friday': 653,
    December: 653,
    January: 653,
    February: 653
  },
  {
    store: 4910,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 4911,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 4912,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4915,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 4916,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 211,
    February: 211
  },
  {
    store: 4918,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: 4919,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307
  },
  {
    store: 4920,
    March: 288,
    April: 288,
    May: 288,
    June: 288,
    July: 288,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 4921,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 4923,
    March: 404,
    April: 404,
    May: 404,
    June: 404,
    July: 404,
    August: 404,
    September: 404,
    October: 404,
    November: 404,
    'Black Friday': 404,
    December: 404,
    January: 403,
    February: 403
  },
  {
    store: 4924,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 4925,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 4926,
    March: 308,
    April: 308,
    May: 308,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307
  },
  {
    store: 4928,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288
  },
  {
    store: 4929,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 4930,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4931,
    March: 288,
    April: 288,
    May: 288,
    June: 288,
    July: 288,
    August: 461,
    September: 461,
    October: 461,
    November: 461,
    'Black Friday': 461,
    December: 461,
    January: 461,
    February: 461
  },
  {
    store: 4935,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 4940,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 4941,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 4942,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 230
  },
  {
    store: 6001,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6002,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6003,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6004,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6005,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6037,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6105,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 6106,
    March: 288,
    April: 288,
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 518,
    February: 595
  },
  {
    store: 6107,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 6113,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6120,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6140,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6150,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6152,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6153,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 384,
    September: 384,
    October: 384,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384,
    February: 384
  },
  {
    store: 6154,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6155,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6158,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6159,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6160,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6161,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6167,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6168,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6169,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6172,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6174,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6175,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6176,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6178,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6201,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6202,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6203,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6204,
    March: 308,
    April: 308,
    May: 308,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307
  },
  {
    store: 6206,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6207,
    March: 442,
    April: 442,
    May: 442,
    June: 442,
    July: 442,
    August: 461,
    September: 461,
    October: 461,
    November: 461,
    'Black Friday': 461,
    December: 461,
    January: 461,
    February: 461
  },
  {
    store: 6208,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6209,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6210,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6212,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6213,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6214,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6215,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6217,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6218,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6220,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 6221,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6223,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6225,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6226,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6228,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 6229,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6230,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 269
  },
  {
    store: 6233,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6234,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6235,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6236,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250,
    February: 326
  },
  {
    store: 6242,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 6301,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6302,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6303,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 250
  },
  {
    store: 6304,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6305,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 288,
    February: 288
  },
  {
    store: 6306,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6310,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6311,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 6312,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6313,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 6314,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6315,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6316,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 6318,
    March: 0,
    April: 0,
    May: 0,
    June: 0,
    July: 0,
    August: 0,
    September: 0,
    October: 0,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6319,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6320,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6321,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6322,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6323,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6324,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6325,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6326,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 6327,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 326,
    February: 326
  },
  {
    store: 6328,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 230,
    February: 230
  },
  {
    store: 6329,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6330,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6331,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 6332,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6334,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 6335,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6336,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 6339,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6340,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 192
  },
  {
    store: 6341,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 230,
    February: 230
  },
  {
    store: 6342,
    March: 0,
    April: 0,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 269,
    February: 269
  },
  {
    store: 6343,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 6346,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6348,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6349,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6350,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6351,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6353,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 6355,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6356,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 6357,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6361,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6363,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 307,
    February: 307
  },
  {
    store: 6364,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6365,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 365,
    February: 365
  },
  {
    store: 6367,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6368,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6369,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6371,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6372,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6373,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6374,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6375,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 6376,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 250
  },
  {
    store: 6377,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6378,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6379,
    March: 288,
    April: 288,
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288
  },
  {
    store: 6380,
    March: 173,
    April: 173,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 250
  },
  {
    store: 6381,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: 6401,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 6402,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 307,
    February: 384
  },
  {
    store: 6403,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 384,
    February: 384
  },
  {
    store: 6405,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: 6407,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 6408,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 230
  },
  {
    store: 6409,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 326,
    February: 326
  },
  {
    store: 6411,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 288,
    February: 288
  },
  {
    store: 6412,
    March: 365,
    April: 365,
    May: 365,
    June: 365,
    July: 365,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365,
    February: 365
  },
  {
    store: 6415,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 653,
    February: 653
  },
  {
    store: 6501,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 230
  },
  {
    store: 6502,
    March: 288,
    April: 288,
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 326,
    February: 326
  },
  {
    store: 6504,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6505,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 6506,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 269,
    February: 269
  },
  {
    store: 6507,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 269
  },
  {
    store: 6509,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6510,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6512,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 230,
    February: 230
  },
  {
    store: 6513,
    March: 308,
    April: 308,
    May: 308,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307
  },
  {
    store: 6514,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: 6515,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250,
    February: 288
  },
  {
    store: 6516,
    March: 288,
    April: 288,
    May: 288,
    June: 288,
    July: 288,
    August: 384,
    September: 384,
    October: 384,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384,
    February: 384
  },
  {
    store: 6517,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6520,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6521,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 6523,
    March: 192,
    April: 192,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: 6525,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6526,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 326
  },
  {
    store: 6528,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6529,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6530,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6531,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6532,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 269
  },
  {
    store: 6533,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6534,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6537,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 6538,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 6539,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6540,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6541,
    March: 0,
    April: 0,
    May: 0,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6542,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6543,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6544,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6545,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6546,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 6547,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6548,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 6549,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250,
    February: 250
  },
  {
    store: 6550,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 6551,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6552,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 615,
    September: 615,
    October: 615,
    November: 730,
    'Black Friday': 730,
    December: 730,
    January: 730,
    February: 730
  },
  {
    store: 6553,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6554,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 6555,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 6556,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 250,
    February: 250
  },
  {
    store: 6557,
    March: 596,
    April: 596,
    May: 596,
    June: 596,
    July: 596,
    August: 596,
    September: 596,
    October: 596,
    November: 634,
    'Black Friday': 634,
    December: 634,
    January: 595,
    February: 595
  },
  {
    store: 6558,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6559,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6560,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6561,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 6562,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6563,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6564,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288
  },
  {
    store: 6566,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6567,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6568,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 692,
    'Black Friday': 692,
    December: 692,
    January: 691,
    February: 691
  },
  {
    store: 6570,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6571,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6572,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288
  },
  {
    store: 6574,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6575,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 211,
    February: 211
  },
  {
    store: 6576,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6577,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6578,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6579,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6580,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6581,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6583,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6584,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6585,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: 6586,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 365,
    February: 365
  },
  {
    store: 6587,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6588,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6589,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6601,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6603,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6604,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 384,
    September: 384,
    October: 384,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384,
    February: 384
  },
  {
    store: 6609,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6610,
    March: 557,
    April: 557,
    May: 557,
    June: 557,
    July: 557,
    August: 557,
    September: 557,
    October: 557,
    November: 557,
    'Black Friday': 557,
    December: 557,
    January: 557,
    February: 557
  },
  {
    store: 6611,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 6612,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6613,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6614,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: 6615,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 230,
    February: 230
  },
  {
    store: 6616,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6617,
    March: 423,
    April: 423,
    May: 423,
    June: 423,
    July: 423,
    August: 423,
    September: 423,
    October: 423,
    November: 423,
    'Black Friday': 423,
    December: 423,
    January: 422,
    February: 422
  },
  {
    store: 6618,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6619,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 307,
    February: 307
  },
  {
    store: 6620,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6621,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6623,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6627,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: 6628,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6629,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 6630,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 288
  },
  {
    store: 6632,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6634,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 6635,
    March: 672,
    April: 672,
    May: 672,
    June: 672,
    July: 672,
    August: 672,
    September: 672,
    October: 672,
    November: 672,
    'Black Friday': 672,
    December: 672,
    January: 672,
    February: 672
  },
  {
    store: 6636,
    March: 576,
    April: 576,
    May: 576,
    June: 576,
    July: 576,
    August: 576,
    September: 576,
    October: 576,
    November: 576,
    'Black Friday': 576,
    December: 576,
    January: 576,
    February: 576
  },
  {
    store: 6637,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 6638,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 6639,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6640,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6643,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 230,
    February: 269
  },
  {
    store: 6644,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 346,
    February: 499
  },
  {
    store: 6645,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 423,
    'Black Friday': 423,
    December: 423,
    January: 480,
    February: 480
  },
  {
    store: 6646,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 6647,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6649,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288
  },
  {
    store: 6650,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 6651,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 6652,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6654,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 6656,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6657,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6660,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6661,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6662,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6663,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6664,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 250,
    February: 250
  },
  {
    store: 6665,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6667,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6668,
    March: 308,
    April: 308,
    May: 308,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 346
  },
  {
    store: 6669,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307
  },
  {
    store: 6670,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6672,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 173,
    February: 173
  },
  {
    store: 6673,
    March: 500,
    April: 500,
    May: 500,
    June: 500,
    July: 500,
    August: 500,
    September: 500,
    October: 500,
    November: 500,
    'Black Friday': 500,
    December: 500,
    January: 499,
    February: 499
  },
  {
    store: 6674,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 346
  },
  {
    store: 6675,
    March: 327,
    April: 327,
    May: 365,
    June: 365,
    July: 365,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 6677,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6678,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 6679,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 307,
    February: 307
  },
  {
    store: 6680,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6681,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6682,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 6683,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 346,
    February: 346
  },
  {
    store: 6684,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: 6687,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 365,
    February: 403
  },
  {
    store: 6688,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 403
  },
  {
    store: 6689,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6701,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: 6804,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6806,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6807,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 326,
    February: 326
  },
  {
    store: 6808,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 6809,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 442,
    September: 442,
    October: 442,
    November: 442,
    'Black Friday': 442,
    December: 442,
    January: 442,
    February: 442
  },
  {
    store: 6814,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6816,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6817,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6818,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 6819,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 6820,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6821,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6822,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6827,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6828,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 230,
    February: 230
  },
  {
    store: 6830,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6831,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6832,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6833,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6834,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 211,
    February: 211
  },
  {
    store: 6835,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6837,
    March: 0,
    April: 0,
    May: 0,
    June: 0,
    July: 0,
    August: 0,
    September: 0,
    October: 0,
    November: 0,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6838,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 192,
    February: 192
  },
  {
    store: 6839,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6840,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6841,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 211,
    February: 211
  },
  {
    store: 6842,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6843,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 6844,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6845,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6846,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6847,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 250,
    September: 250,
    October: 250,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 442,
    February: 442
  },
  {
    store: 6848,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6851,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6852,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6853,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6855,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6856,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6857,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6859,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6860,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 403,
    February: 403
  },
  {
    store: 6861,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6862,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 6863,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 250
  },
  {
    store: 6864,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 6865,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6866,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 365,
    February: 422
  },
  {
    store: 6869,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346
  },
  {
    store: 6871,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6872,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6874,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 6875,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 6876,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 6877,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6878,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6883,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6884,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6887,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 6888,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6889,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6890,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6891,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288
  },
  {
    store: 6892,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6893,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 557,
    September: 557,
    October: 557,
    November: 634,
    'Black Friday': 634,
    December: 634,
    January: 787,
    February: 787
  },
  {
    store: 6903,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 326,
    February: 326
  },
  {
    store: 6905,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6911,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6917,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326
  },
  {
    store: 6918,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6919,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 269,
    February: 346
  },
  {
    store: 6920,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6921,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6923,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 269,
    February: 269
  },
  {
    store: 6925,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288
  },
  {
    store: 6928,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6930,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6931,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250,
    February: 269
  },
  {
    store: 6932,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6934,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6935,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6936,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6940,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6941,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6942,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6943,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6945,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6946,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6947,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6948,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6950,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6951,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307
  },
  {
    store: 6952,
    March: 288,
    April: 288,
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288
  },
  {
    store: 6954,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 307,
    February: 307
  },
  {
    store: 6955,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6956,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6957,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6959,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6960,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6961,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6963,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288
  },
  {
    store: 6964,
    March: 404,
    April: 404,
    May: 404,
    June: 404,
    July: 404,
    August: 404,
    September: 404,
    October: 404,
    November: 404,
    'Black Friday': 404,
    December: 404,
    January: 403,
    February: 518
  },
  {
    store: 6965,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6966,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6967,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 192,
    February: 192
  },
  {
    store: 6968,
    March: 365,
    April: 365,
    May: 365,
    June: 365,
    July: 365,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365,
    February: 365
  },
  {
    store: 6971,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6972,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6974,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 269,
    February: 346
  },
  {
    store: 6975,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 288,
    February: 288
  },
  {
    store: 6976,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6977,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6978,
    March: 596,
    April: 596,
    May: 596,
    June: 596,
    July: 596,
    August: 634,
    September: 634,
    October: 634,
    November: 634,
    'Black Friday': 634,
    December: 634,
    January: 634,
    February: 634
  },
  {
    store: 6979,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 6980,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 192
  },
  {
    store: 6981,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6984,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6985,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6986,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 6987,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 6988,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 6989,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 8201,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 8408,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8412,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8413,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8418,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 230,
    February: 230
  },
  {
    store: 8419,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8426,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8427,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8429,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 8430,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8431,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 8433,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8437,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8438,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 8439,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 8440,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8444,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288
  },
  {
    store: 8445,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 8446,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8447,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8452,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 8453,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 8454,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 8456,
    March: 404,
    April: 404,
    May: 404,
    June: 404,
    July: 404,
    August: 404,
    September: 404,
    October: 404,
    November: 404,
    'Black Friday': 404,
    December: 404,
    January: 403,
    February: 403
  },
  {
    store: 8460,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 8463,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 8465,
    March: 404,
    April: 404,
    May: 404,
    June: 404,
    July: 404,
    August: 404,
    September: 404,
    October: 404,
    November: 442,
    'Black Friday': 442,
    December: 442,
    January: 403,
    February: 403
  },
  {
    store: 8466,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 8469,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8472,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8473,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 8475,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 8488,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8492,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 8493,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8517,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 8518,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8519,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 8520,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 8521,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 230,
    February: 230
  },
  {
    store: 8523,
    March: 288,
    April: 288,
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288
  },
  {
    store: 8524,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8525,
    March: 365,
    April: 365,
    May: 365,
    June: 365,
    July: 365,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 442,
    February: 634
  },
  {
    store: 8526,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8527,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8528,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230
  },
  {
    store: 8529,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 230
  },
  {
    store: 8531,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8537,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8539,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8540,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8545,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 8548,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8550,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 8551,
    March: 500,
    April: 500,
    May: 500,
    June: 500,
    July: 500,
    August: 557,
    September: 557,
    October: 557,
    November: 557,
    'Black Friday': 557,
    December: 557,
    January: 557,
    February: 557
  },
  {
    store: 8552,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8557,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 442,
    February: 518
  },
  {
    store: 8560,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 8561,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288
  },
  {
    store: 8562,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 365
  },
  {
    store: 8563,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 307
  },
  {
    store: 8566,
    March: 423,
    April: 423,
    May: 423,
    June: 423,
    July: 423,
    August: 423,
    September: 423,
    October: 423,
    November: 423,
    'Black Friday': 423,
    December: 423,
    January: 422,
    February: 422
  },
  {
    store: 8571,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 269,
    February: 269
  },
  {
    store: 8572,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8577,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8580,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8582,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 8583,
    March: 557,
    April: 557,
    May: 557,
    June: 557,
    July: 557,
    August: 557,
    September: 557,
    October: 557,
    November: 557,
    'Black Friday': 557,
    December: 557,
    January: 557,
    February: 557
  },
  {
    store: 8584,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8597,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 8598,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 211
  },
  {
    store: 8622,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 173,
    February: 173
  },
  {
    store: 8913,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8916,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8918,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8919,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8922,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 8923,
    March: 365,
    April: 365,
    May: 365,
    June: 365,
    July: 365,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365,
    February: 365
  },
  {
    store: 8924,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 8926,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8929,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269
  },
  {
    store: 8931,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 8938,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8939,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 8940,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 384,
    February: 384
  },
  {
    store: 8941,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 326,
    February: 326
  },
  {
    store: 8944,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 8949,
    March: 192,
    April: 192,
    May: 308,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307
  },
  {
    store: 8951,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8954,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8955,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 8958,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8964,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8966,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8975,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8976,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8979,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8981,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  },
  {
    store: 8984,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8987,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 346,
    February: 346
  },
  {
    store: 8988,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192
  },
  {
    store: 8994,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250
  },
  {
    store: 8995,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 250
  },
  {
    store: 8996,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173
  },
  {
    store: 8998,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211
  }
];